import { create } from "zustand";
import type { IAddedFixedPayout } from "../hooks/http/admin/campaigns/get-fixed-payouts.http";

interface IFixedPayoutStore {
  data: IAddedFixedPayout[];
  setData: (data: IAddedFixedPayout[]) => void;
  removeById: (id: string) => void;
}

const useSelectedFixedPayoutStore = create<IFixedPayoutStore>((set) => ({
  data: [],
  setData: (data: IAddedFixedPayout[]) => set(() => ({ data })),
  removeById: (id: string) =>
    set((state) => ({
      data: state.data.filter((user) => user.id !== id),
    })),
}));

export default useSelectedFixedPayoutStore;
